import styled from 'styled-components';

export const LoadingContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.87);
  z-index: 9999;
`;

export const LoadingGif = styled.img`
  width: 150px;
  height: 150px;
  object-fit: contain;
`;
